import champsService from '../services/champsService'
import { clone, sortBy } from 'lodash'

const defaultState = {
  clubCode: null,
  clubTraining: [],
  clubTrainingFilters: {},
  clubTrainingsLoaded: false
}

const state = clone(defaultState)

const mutations = {
  addClubTraining (state, data) {
    state.clubTraining = state.clubTraining.concat(data.items)
  },
  clearClubTraining (state) {
    state.clubTraining = []
  },
  filtersUpdate (state, data) {
    state.clubTrainingFilters = data.data
  },
  setTrainingsLoadedStatus (state, status) {
    state.clubTrainingsLoaded = status
  },
  resetClubTraining (state) {
    for (const key in defaultState) {
      state[key] = defaultState[key]
    }
  }
}

const getters = {
  citiesFilterValues (state) {
    const result = [{ id: 'any', name: 'Любой' }]
    let values = state.clubTrainingFilters.cities

    if (!values) {
      return result
    }

    values = sortBy(values, (o) => o.toLowerCase())

    for (let i = 0; i < values.length; i++) {
      const option = values[i]
      result.push({
        id: option,
        name: option
      })
    }
    return result
  },
  disciplinesFilterValues (state) {
    const result = [{ id: 'any', name: 'Любая' }]
    if (!state.clubTrainingFilters.disciplines) {
      return result
    }
    const values = state.clubTrainingFilters.disciplines
    for (let i = 0; i < values.length; i++) {
      const option = values[i]
      const name = option.value === 'Велосипедный спорт' ? 'Велозаезд' : option.value

      result.push({
        id: option.code,
        name: name
      })
    }
    return result
  }
}

const actions = {
  getClubTraining ({ state, commit }, data) {
    return champsService.getClubTraining(data.data)
      .then(response => {
        commit('addClubTraining', {
          items: response.data
        })
        state.clubCode = data.clubCode
      })
  },
  getClubTrainingCount ({ state }, data) {
    return champsService.getClubTrainingCount(data)
  },
  getTrainingFilters ({ state, commit }, data) {
    return champsService.getTrainingFilters(data)
      .then((response) => {
        commit('filtersUpdate', {
          data: {
            cities: response.data.Cities,
            disciplines: response.data.Disciplines.map((item) => {
              return {
                code: item.Code,
                value: item.Value
              }
            }),
            genders: response.data.Genders
          }
        })
      })
  },
  clearClubTraining ({ state, commit }) {
    commit('clearClubTraining')
  }
}

export const clubTraining = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
